export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "providerchat.worker.d61b10ccc45f7a1e9b67.worker.js");
}
